import { BLOG_PATH, MainRoutes } from '@/utils/routes'
import { Briefcase, DollarSign } from 'lucide-react'

const SALARY_TITLE = 'Salaries'

const globalNavItems = [
  { name: 'Home', href: MainRoutes.Home, isMobileOnly: true },
  { name: SALARY_TITLE, href: MainRoutes.DefaultSalary, icon: <DollarSign /> },
  {
    name: 'Jobs',
    href: MainRoutes.Jobs,
    icon: <Briefcase />,
  },
  {
    name: 'Blog',
    href: `${process.env.NEXT_PUBLIC_BASE_URL}${BLOG_PATH}`,
  },
]

export function getGlobalNavItems(opts?: { isAuthenticated: boolean }): Array<{
  name: string
  href: string
  icon?: React.ReactNode
  isMobileOnly?: boolean
  isExternal?: boolean
}> {
  if (opts?.isAuthenticated) {
    // Update Salaries route to MainRoutes.Salary for authenticated users.
    // We do this so that the salary middleware logic routes auth'd users
    // to the appropriate salary page.
    const salaryItemIndex = globalNavItems.findIndex(
      (item) => item.name === SALARY_TITLE,
    )
    if (salaryItemIndex !== -1) {
      globalNavItems[salaryItemIndex] = {
        ...globalNavItems[salaryItemIndex],
        href: MainRoutes.Salary,
      }
    }
  }

  return globalNavItems
}
